const uiHelpers = {
  computed: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    /**
     * use to navigate to all the end-user components
     * @param {*} page
     * @param {*} params
     */
    goToPage(page, params = 'component') {
      this.$router.push({
        name: page,
        params,
      });
    },

    /**
     * generic function to find id and scroll to that section
     * @param id
     */
    scrollToId(id) {
      const element = document.getElementById(id);
      const headerOffset = 56;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    },
  },
};

export { uiHelpers as default };
